import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/services/user.service';
import Resource from 'src/app/interfaces/Resource';
import { ResourceService } from 'src/app/services/resource.service';
import { LoadingService } from 'src/app/services/loading.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.scss'],
})
export class ResourcesComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  currentUser;
  locked = false;
  resources: Array<Resource> = [];
  filteredResources: Array<Resource> = [];
  limit = 10;
  params = null;

  constructor(
    private userService: UserService,
    private resourceService: ResourceService,
    private loadingService: LoadingService,
    private analyticsService: AnalyticsService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.analyticsService.event('resource_view');
    this.subscriptions.add(
      this.userService.user.subscribe((u) => {
        if (u && u.uid) {
          this.currentUser = u;
          this.locked = false;
          this.loadingService.startLoading();
          this.resourceService.getResources(50).subscribe(
            (d) => {
              this.resources = d;
              this.filteredResources = this.resources;
              this.loadingService.stopLoading();
              if (this.resources.length >= 50) {
                this.lazyLoad();
              }
            },
            (e) => console.error(e)
          );
        } else {
          this.locked = true;
        }
      })
    );
  }

  lazyLoad() {
    this.subscriptions.add(
      this.resourceService.getAllResources().subscribe((lazyResources) => {
        this.resources = lazyResources;
        this.resources.forEach((r) => {
          // if (r.coauthors.length) console.log(r)
        })
        this.filteredResources = this.resources;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  filterChange(f) {
    this.filteredResources = f.filteredList;
  }

  cardEvent(e, comment, expand = null) {
    if (e.type === 'update_resource') {
      this.resourceService.updateResource(e.id, e.update);
    }
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    let y = window.pageYOffset;
    let max = document.querySelector('.thread-wrap').scrollHeight;
    if (max - 500 <= y) {
      if (this.limit < this.resources.length) {
        this.limit += 10;
      }
    }
  }
}
